import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function createFolder(body:any, query:any)
{
	return API.post('folderManagement', `/folders${query}`, { body });
}

export function createNestedFolder(body:any, query:any)
{
	return API.post('folderManagement', `/nestedFolder${query}`, { body });
}

export function getFolder(query:any)
{
	return API.get('folderManagement', `/folders${query}`, init);
}
export function getMembersTable(id:any)
{
	return API.get('folderManagement', `/sharedMembers/${id}`, init);
}
export function updateFolder(body)
{
	return API.put('folderManagement', '/folders', { body });
}
export function updateFolder2(body:any, query:any)
{
	return API.put('folderManagement', `/folders${query}`, { body });
}
export function deleteFolder(body, query)
{
	return API.del('folderManagement', `/folders${query}`, { body });
}
export function getFolderById(path:any)
{
	return API.get('folderManagement', `/folders/${path}`, init);
}

export function whiteLabel(body:null)
{
	return API.post('folderManagement', '/whitelabel', { body });
}

export function whiteLabel2(body:null, query)
{
	return API.post('folderManagement', `/whitelabel${query}`, { body });
}

export function getFolderAccessRelationAndMembers(query)
{
	return API.get('folderManagement', `/sharedMembers${query}`, init);
}
export function moveFolder(body:any, query:any)
{
	return API.put('folderManagement', `/moveFolder${query}`, { body });
}
export function moveFolderToParent(body:any, query:any)
{
	return API.put('folderManagement', `/moveToParent${query}`, { body });
}
export function getSharedList(query:any)
{
	return API.get('folderManagement', `/getSharedFiles${query}`, init);
}
export function shareWithCompaniesEmp(query:any)
{
	return API.get('folderManagement', `/shareWith${query}`, init);
}

export function getSharedCompaniesList(query:any)
{
	return API.get('folderManagement', `/SearchCompany${query}`, init);
}

export function updateFolderAccess(body:any, query:any)
{
	return API.put('folderManagement', `/folders${query}`, { body });
}